import useReveal from "@/hooks/useReveal";

/**
 * A large archival chapter divider — Roman numeral + title + lede.
 * Used between major sections of the site.
 */
export default function ChapterDivider({ numeral, kicker, title, lede, id }) {
  const ref = useReveal();
  return (
    <section
      id={id}
      ref={ref}
      className="reveal relative z-10 py-20 sm:py-28 md:py-36 bg-[var(--c-bg)] border-t border-[var(--c-border)] scroll-mt-16 sm:scroll-mt-20"
      data-testid={`chapter-${id}`}
    >
      <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-10 lg:px-16">
        <div className="grid md:grid-cols-[auto,1fr] gap-8 md:gap-16 items-baseline">
          {/* Numeral plate */}
          <div className="relative">
            <span
              className="block font-serif-grand font-semibold italic text-[5.5rem] xs:text-[7rem] md:text-[10rem] lg:text-[13rem] leading-[0.8] tracking-tighter text-[var(--c-accent)]"
              aria-hidden="true"
              data-testid={`chapter-${id}-numeral`}
            >
              {numeral}
            </span>
            <span
              className="absolute -bottom-2 left-0 w-20 sm:w-28 h-[2px] bg-[var(--c-accent)]"
              aria-hidden="true"
            />
          </div>
          <div className="pt-4 md:pt-10">
            <p className="overline mb-3 sm:mb-4">{kicker}</p>
            <h2 className="font-serif-display text-3xl xs:text-4xl md:text-5xl lg:text-6xl text-[var(--c-text)] tracking-tight leading-[1.05]">
              {title}
            </h2>
            {lede && (
              <p className="drop-cap mt-5 sm:mt-7 max-w-2xl text-[var(--c-text-muted)] text-sm sm:text-base md:text-lg leading-relaxed">
                {lede}
              </p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
}
